import { useEffect } from 'react';

import { Chat } from '@ui-furniture/common/chat-ui';

import { useQuestionnaireWithWebChat } from './use-questionnaire-with-web-chat';
import { WebChatQuestionnaire } from './web-chat-questionnaire';

export function ChatBotUsingQuestionnaire<TData extends object>({
  questionnaire,
  initialData,
  onDone,
}: {
  questionnaire: WebChatQuestionnaire<TData, any>;
  initialData: TData;
  onDone?: (data: TData) => any;
}) {
  const { chatState, start } = useQuestionnaireWithWebChat(questionnaire, {
    initialData,
    onDone,
  });
  useEffect(() => start(), []);

  return <Chat state={chatState} />;
}
